import Api from '@/api/Api';
//import axios from 'axios';
import errorHandler from '@/utils/plugins/ErrorHandler';

const RESOURCE_NAME = '/api/vehicles';

export default {
    // VEHICLES
    getVehicles(params) {
        return Api().get(RESOURCE_NAME, {params: params})
            .catch((err) => errorHandler(err, null));
    },
    getVehicle(id) {
        return Api().get(RESOURCE_NAME + `/${id}`)
            .catch((err) => errorHandler(err, null));
    },
    createVehicle(item) {
        return Api().post(RESOURCE_NAME, item)
        .catch((err) => errorHandler(err, null));
    },
    updateVehicle(id, item) {
        return Api().put(RESOURCE_NAME + `/${id}`, item)
        .catch((err) => errorHandler(err, null));
    },
    deleteVehicle(id) {
        return Api().delete(RESOURCE_NAME + `/${id}`)
        .catch((err) => errorHandler(err, null));
    },
    registerAdBlue(id) {
        return Api().post(RESOURCE_NAME + `/${id}/register-adblue`,{})
            .catch((err) => errorHandler(err, null));
    },
}
